import template from './ticketTile.template.html';

export default {
  template,
  bindings: {
    workflow: '<',
    stage: '<',
    ticket: '<',
    labels: '<',
    accounts: '<',
    partners: '<',
    contacts: '<',
    tileColors: '<',
    tileActions: '<',
    showOwner: '<',
    showPartner: '<',
    showClient: '<',
    showLabels: '<',
    showDueDate: '<',
    showFinanceDueDate: '<',
    showValue: '<',
    isTicketEditAllowed: '<',
    onTileColorChange: '&',
    onJobAdd: '&',
    onNoteAdd: '&',
    onLabelsSelect: '&',
    onMoveToAnotherWorkflow: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdUtil,
      clipboard,
      emailService,
      uiService,
      eventService,
      ticketService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
      ctrl.currentLocale = $rootScope.CurrentLocale();
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();

      ctrl.account = null;
      ctrl.partner = null;
      ctrl.contact = null;
      ctrl.value = 0;

      ctrl.initialize = (isInitial) => {
        ctrl.tileActions = ctrl.tileActions || [];
        if (ctrl.showOwner && ctrl.accounts?.length > 0) {
          ctrl.account = _.find(ctrl.accounts, (a) => a.id === ctrl.ticket?.idOwner);
        }
        if (ctrl.showPartner && ctrl.partners?.length && ctrl.ticket?.idPartners[0]) {
          ctrl.partner = _.find(ctrl.partners, (p) => p.id === ctrl.ticket?.idPartners[0]);
        }
        if (ctrl.showClient && ctrl.contacts?.length && ctrl.ticket?.idClients[0]) {
          ctrl.contact = _.find(ctrl.contacts, (c) => c.id === ctrl.ticket?.idClients[0]);
        }
        if (isInitial) {
          ctrl.value = ctrl.ticket.getValue(100);
          ctrl.setTicketStatus();
          ctrl.setTicketClass();
        }
      };

      ctrl.bccCopy = ($event) => {
        $event.stopPropagation();
        clipboard.copyText(emailService.getTicketEmail(ctrl.ticket.uuid));
        uiService.toast({
          text: {
            p1: 'E-Mail to notes',
            p2: 'address',
            p3: 'copied to clipboard'
          }
        });
      };

      ctrl.noteAdd = ($event) => {
        $event.stopPropagation();
        $event.preventDefault();
        ctrl.onNoteAdd({ event: $event, note: null, ticket: ctrl.ticket });
      };

      ctrl.jobAdd = ($event) => {
        $event.stopPropagation();
        $event.preventDefault();
        ctrl.onJobAdd({ event: $event, job: null, ticket: ctrl.ticket });
      };

      ctrl.labelsSelect = ($event) => {
        ctrl.onLabelsSelect({ event: $event, ticket: ctrl.ticket });
      };

      ctrl.moveToAnotherWorkflow = ($event) => {
        ctrl.onMoveToAnotherWorkflow({ event: $event, ticket: ctrl.ticket });
      };

      ctrl.onTileColorPicked = (tileColor) => {
        ctrl.ticket.tileColor = tileColor;
        ticketService.updateTicket({ id: ctrl.ticket.id, tileColor }).then((result) => {
          if (result.status) {
            ctrl.setTicketClass();
            ctrl.onTileColorChange();
          }
        });
      };

      ctrl.setTicketStatus = () => {
        if (ctrl.showDueDate && !ctrl.showFinanceDueDate) {
          ctrl.ticketStatus = ctrl.ticket.getDueDate(ctrl.currentTimeZone, ctrl.currentLocale);
        }
        if (!ctrl.showDueDate && ctrl.showFinanceDueDate) {
          ctrl.ticketStatus = ctrl.ticket.getFinanceDueDate(
            ctrl.currentTimeZone,
            ctrl.currentLocale
          );
        }
        ctrl.ticketStatus += ticketService.getTicketStatus(
          ctrl.ticket,
          ctrl.showFinanceDueDate
        );
      };
      ctrl.setTicketClass = () => {
        ctrl.ticketClass = '';
        ctrl.ticketClass += ctrl.ticket?.tileColor
          ? `${String(ctrl.ticket?.tileColor).replace(/[_]+/gi, '-')}-bg`
          : '';
        ctrl.ticketClass += ticketService.setTicketClass(ctrl.ticket, ctrl.showFinanceDueDate);
      };

      ctrl.$onInit = () => {
        ctrl.initialize(true);
      };

      ctrl.$onChanges = () => {
        ctrl.initialize(false);
      };
    }
  }
};
